import { render, staticRenderFns } from "./TopicData.vue?vue&type=template&id=5e8ea12c&scoped=true&"
import script from "./TopicData.vue?vue&type=script&lang=js&"
export * from "./TopicData.vue?vue&type=script&lang=js&"
import style0 from "./TopicData.vue?vue&type=style&index=0&id=5e8ea12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ea12c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
